$(document).ready(function() {
  $('.fund-select').on('change', function() {
    const fundId = $(this).val();

    if (fundId) {
      $.get(`/funds/${fundId}.json`, function(data) {
        $('#proposal_fund_name').val(data.name).prop('readonly', true);
        $('#proposal_fund_cnpj').val(data.cnpj).prop('readonly', true);
        $('#proposal_fund_administrator').val(data.administrator).prop('readonly', true);
        $('#proposal_fund_custody').val(data.custody).prop('readonly', true);
      });
    } else {
      $('#proposal_fund_name').val('').prop('readonly', false); 
      $('#proposal_fund_cnpj').val('').prop('readonly', false);
      $('#proposal_fund_administrator').val('').prop('readonly', false);
      $('#proposal_fund_custody').val('').prop('readonly', false);
    }
  });
});
